import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["expandableContent", "chevron"]

  toggle(event) {
    event.preventDefault()

    const content = this.expandableContentTarget
    const chevron = this.chevronTarget

    if (content.classList.contains('hidden')) {
      // Expand
      content.classList.remove('hidden')
      chevron.classList.add('rotate-90')
    } else {
      // Collapse
      content.classList.add('hidden')
      chevron.classList.remove('rotate-90')
    }
  }
}
